import { collection, getDocs, limit, query } from "firebase/firestore";
import {
  buildArchiveDateKeys,
  collectionNamesForDate,
  DAILY_CONTENT_RETENTION_DAYS,
} from "./contentDate";

/**
 * Newest-first edition dates that have articles in Firestore (within the retention window).
 */
export async function discoverArchiveDateKeys(
  db,
  londonToday,
  maxDays = DAILY_CONTENT_RETENTION_DAYS
) {
  const candidates = buildArchiveDateKeys(londonToday, maxDays);
  const results = await Promise.all(
    candidates.map(async (dateKey) => {
      const { news: collectionName } = collectionNamesForDate(dateKey);
      try {
        const snap = await getDocs(
          query(collection(db, collectionName), limit(1))
        );
        return snap.empty ? null : dateKey;
      } catch (err) {
        console.warn(`Could not read ${collectionName}:`, err.message);
        return null;
      }
    })
  );
  return results.filter(Boolean);
}
